import { AlertTriangle, Check } from "lucide-react";
import { Shell, StepFooter } from "@/components/Shell";

export function Disclaimer({ consent, setConsent, onBack, onNext }) {
  return (
    <Shell progress={5}>
      <span className="cc-eyebrow">Aviso</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Orientación general, no diagnóstico
      </h1>
      <p className="mt-4 text-[hsl(var(--muted-foreground))] leading-relaxed">
        Climaterio Claro no diagnostica, no interpreta estudios y no recomienda
        medicamentos, hormonas, suplementos ni tratamientos. Tampoco sustituye a una
        consulta médica ni a los servicios de urgencia.
      </p>

      <div className="mt-6 rounded-2xl border-2 border-[hsl(var(--coral))] bg-[hsl(var(--coral))]/10 p-5">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-6 w-6 text-[hsl(var(--coral))] shrink-0 mt-0.5" aria-hidden="true" />
          <div>
            <h2 className="font-serif text-lg font-semibold text-[hsl(var(--texto))]">
              Busca atención urgente si presentas:
            </h2>
            <ul className="mt-2 space-y-1.5 text-sm text-[hsl(var(--texto))]">
              <li>• Dolor de pecho</li>
              <li>• Dificultad importante para respirar</li>
              <li>• Desmayo</li>
              <li>• Sangrado incontrolable</li>
              <li>• Pensamiento de hacerse daño</li>
            </ul>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => setConsent(!consent)}
        data-testid="consent-checkbox"
        aria-pressed={consent}
        className="mt-6 w-full flex items-start gap-3 rounded-2xl border-2 p-4 text-left transition-all"
        style={{
          borderColor: consent ? "hsl(var(--olivo))" : "hsl(33 25% 82%)",
          backgroundColor: consent ? "hsl(var(--olivo) / 0.08)" : "white",
        }}
      >
        <span
          className={`h-6 w-6 shrink-0 rounded-md border-2 flex items-center justify-center mt-0.5 ${
            consent
              ? "border-[hsl(var(--olivo))] bg-[hsl(var(--olivo))]"
              : "border-[hsl(33_25%_75%)] bg-white"
          }`}
          aria-hidden="true"
        >
          {consent && <Check className="h-4 w-4 text-white" />}
        </span>
        <span className="text-[hsl(var(--texto))] font-medium">
          Entiendo los límites y continuaré sin introducir datos personales reales.
        </span>
      </button>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="disclaimer-back-btn">
          Atrás
        </button>
        <button
          onClick={onNext}
          disabled={!consent}
          className="cc-btn-primary"
          data-testid="disclaimer-next-btn"
        >
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
